import { hooks } from '@/store.js'
import { Habit } from '@habitus/verdant'
import { Editor } from './Editor/index.jsx'

export const DescriptionInput = ({ habit }: { habit: Habit }) => {
  const client = hooks.useClient()

  const { description } = hooks.useWatch(habit)

  return (
    <Editor
      initialValue={description}
      placeholder="Description..."
      onChange={(editorState) => {
        client
          .batch({ undoable: false })
          .run(() => {
            habit.set('description', JSON.stringify(editorState))
          })
          .commit()
      }}
    />
  )
}
